import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ExternalCommonService } from '../../../shared/services/external.common.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-downloadpaymentfailed',
  templateUrl: './downloadpaymentfailed.component.html',
  styleUrls: ['./downloadpaymentfailed.component.scss'],
})
export class DownloadpaymentfailedComponent implements OnInit {
  constructor(
    private router: ActivatedRoute,
    private routerService: Router
  ) {}
  requestId: any;

  ngOnInit(): void {
    this.requestId = +atob(this.router.snapshot.params.id);
    this.routerService.navigate([`/registrydownload/${btoa(this.requestId)}`], { queryParams: { ifpf: btoa('true') } });
  }
}
